export const SIGNUPSTEPS = "signupsteps";

export const REGISTRATION_TYPE_FULL_SAAS = 1;
export const REGISTRATION_TYPE_PARTIAL_FREE_SAAS = 2;
export const REGISTRATION_TYPE_FREE_SAAS = 3;
export const REGISTRATION_TYPE_RESELLER_A = 4;
export const REGISTRATION_TYPE_RESELLER_B = 5;
export const REGISTRATION_TYPE_PARTNER_A = 6;
export const REGISTRATION_TYPE_PARTNER_B = 7;